import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import 'intl-tel-input';
import { FormValidationComponent } from '../../../form-validation/form-validation.component';
import { Utility } from '../../../shared/utility/utility';
import { CustomValidators } from '../../../shared/utility/custom-validator';
import { AjaxService } from '../../../services/ajax.service';
import { AppDetailsService } from '../../../services/app-details.services';
import { EmitterService } from '../../../services/emitter.service';
import { UserDetailsService } from '../../../services/user-details.service';
import { ProfileSettingService } from '../../../services/profile-setting.service';
import { TranslateService } from '@ngx-translate/core';
import { CountryDataService } from '../../../services/country.service';
import { language, statesAvailableCountrys } from '../../../shared/utility/config';
import { environment } from '../../../../environments/environment';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as _ from 'underscore';
import * as $ from 'jquery';


@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
  styleUrls: ['./update-profile.component.scss']
})
export class UpdateProfileComponent extends FormValidationComponent implements OnInit, OnDestroy {

  @Input() callingFrom;
  @Output() updateProfileComplete = new EventEmitter<string>();

  focusedElement;
  yearRange = [];
  availableCountries;
  ipCountry;
  ipCurrCountry;
  serverError;
  userDetails;
  countries;
  isRealUser;
  message: boolean = false;
  isProfileCompleted;
  langCode;
  availableStates;
  isSelectedCountryStateDataAvailable = false;
  isSubmitted = false;
  updateprofile = this.formBuilder.group({
    'firstName': ['', [this.CustomValidators.validName(2, 30)]],
    'lastName': ['', [this.CustomValidators.validName(2, 30)]],
    'address1': ['', this.CustomValidators.addressValidator(false)],
    'zipCode': ['', this.CustomValidators.validAlphaNumeric(2, 10)],
    'countryCode': ['', this.CustomValidators.required],
    'areaCode': [''],
    'areaCountryCode': [''],
    'phoneNumber': ['', [this.countryDataService.ipCountry == 'SE' ? this.CustomValidators.phoneNumberValidatorSE(this.utils) : this.CustomValidators.phoneNumberValidator]],
    'gender': [],
    'email': ['', this.CustomValidators.required],
    'dob': ['', ''],
    'dob1': ['', ''],
    'dob2': ['', ''],
    'playerID': [],
    'city': ['', this.CustomValidators.validName(2, 50)]
  });
  @Output() triggerAccountMenu = new EventEmitter<{}>();
  isCountryAllowed: any;
  destroy$: Subject<boolean> = new Subject<boolean>();
  excludedCountryList = _.union(environment.trustlyCountries, environment.fullPnpCountries)
  toggleSwedenLable;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private utils: Utility,
    private CustomValidators: CustomValidators,
    private ajaxService: AjaxService,
    private appDetails: AppDetailsService,
    private emitterService: EmitterService,
    private userDetailsService: UserDetailsService,
    private profileSettingService: ProfileSettingService,
    private translationService: TranslateService,
    private router: Router,
    private countryDataService: CountryDataService
  ) {
    super(utils);
    this.emitterService.userDataSource$.pipe(takeUntil(this.destroy$)).subscribe(userDataSource => {
      if (userDataSource === "User Data Updated") {
        this.userDetails = this.userDetailsService.getUserProfileDetails();
        this.isRealUser = this.userDetails && this.userDetails.userStatus === "real" ? true : false;
        this.updateFormFields();
        this.updateAvailableCountries();
      }
    });

    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });

    this.emitterService.txnComplete$.pipe(takeUntil(this.destroy$)).subscribe(transactionStatus => {
      //closeBanner wont be called, as more than one call is disrupting the motto
      if (transactionStatus === 'SUCCESS') {
        this.isRealUser = true;
        this.updateAvailableCountries();
      }
    });

    this.emitterService.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.isCountryAllowed = data;
    })

    if(this.countryDataService.ipCountry == "SE"){
      this.emitterService.toggleLabelForSweden$.pipe(takeUntil(this.destroy$)).subscribe(status=>{
        this.toggleSwedenLable = status
      })
    }

    this.updateAvailableCountries();
  }

  ngOnInit() {
    this.ipCurrCountry=this.countryDataService.ipCountry;
    this.langCode = localStorage.getItem('langCode');
    this.getCountry();
  }
  getCountry() {

    Promise.resolve(this.countryDataService.getCountriesDetails()).then(regData => {
      let ipCountry = regData["country"]
      this.availableCountries = regData["countrylist"].filter(country => (this.excludedCountryList).indexOf(country.iso) === -1).filter((country)=> ipCountry != "SE" && country.name!="Sweden");
      /*Once country details are filled we then move for next processing as they use the country details */
      this.initialstep(ipCountry);
    });
  }
  initialstep(ipCountry) {
    this.availableCountries = this.countryDataService.getCountries()
      .filter(country => (this.excludedCountryList).indexOf(country.iso) === -1)
      .filter((country)=> ipCountry != "SE" && country.name!="Sweden");;
    if (this.availableCountries) {
      this.updateAvailableCountries();
    } else {
      Promise.resolve(this.countryDataService.getCountriesDetails()).then(countryData => {
        this.availableCountries = countryData["countrylist"].filter(country => (this.excludedCountryList).indexOf(country.iso) === -1);
        this.appDetails.setAvailableCountries(countryData);
        this.updateAvailableCountries();
      },
        SystemError => {
        });
    }
    Promise.resolve(this.profileSettingService.getProfileData(false)).then(profileData => {
      this.userDetails = this.userDetailsService.getUserProfileDetails();
      this.updateFormFields();
    })
    Promise.resolve(this.userDetailsService.checkUserProfile()).then(profileData => {
      this.isProfileCompleted = profileData && profileData["userProfileCompleted"] ? true : false;
    });
  }

  /** 
   * when user becomes real not restricting the trustlyCountries in the availableCountries array,
   * so if a real user is from trustly based country, then user can see country in the field 
   * */
  updateAvailableCountries() {
    this.userDetails = this.userDetailsService.getUserProfileDetails();
    this.isRealUser = this.userDetails && this.userDetails.userStatus === "real" ? true : false;
    if (this.isRealUser) {
      this.availableCountries = this.countryDataService.getCountries();
      if (this.availableCountries) {
        this.setAvailableCountriesData(this.availableCountries);
      }
    }
  }
  onCountrySelect(isFromUpdate = false) {
    let selectedCountry = this.updateprofile.controls['countryCode'].value;
    let countryAvailableStates = statesAvailableCountrys;
    let selectedCountryInfo: any = {}
    if (countryAvailableStates && countryAvailableStates.length) {
      selectedCountryInfo = countryAvailableStates.filter((country) => country.countryIso === selectedCountry && country.isEnabled);
      if (selectedCountryInfo && !_.isEmpty(selectedCountryInfo)) {
        let stateValidation = new FormControl('', this.CustomValidators.required);
        this.updateprofile.addControl('state', stateValidation);
        this.availableStates = selectedCountryInfo[0].countryStates;
        if (isFromUpdate && this.userDetails["state"] && this.userDetails["state"] != '-NA-') {
          this.updateprofile.controls["state"].setValue(this.userDetails['state']);
        } else {
          this.updateprofile.controls["state"].setValue(selectedCountryInfo[0].defaultState);
        }
        this.isSelectedCountryStateDataAvailable = true;
      } else {
        this.updateDefault();
      }
    } else {
      this.updateDefault();
    }
  }
  updateDefault(){
    this.isSelectedCountryStateDataAvailable = false;
    this.updateprofile.removeControl('state');
  }
  
  setAvailableCountriesData(countryData) {

    if (countryData) {
      this.ipCountry = this.countryDataService.ipCountry;
      this.availableCountries = countryData;
    }
    setTimeout(() => {
      this.updateprofile.setValidators(this.CustomValidators.validateCheckMobile(this.ajaxService, true, this.userDetails));
    });
  }
  checkmobilereg(buttonId, check,isUpdateProfile=null) {
    if(isUpdateProfile == 'update-profile'){
      this.isSubmitted = true;
    }
    let signUpData = this.utils.formControlToParams(this.updateprofile, {});
    let trimmedNumber = this.utils.trimNumberBasedOnCountryRequirement(signUpData.countryCode, signUpData);
    let validateValues = {
      mobileNumber: trimmedNumber,
      mobileIsdCode: signUpData.areaCode
    }
    if (!signUpData.phoneNumber || !signUpData.areaCode) {
      let message = { 'message': CustomValidators.translationService.instant('errors.error10') };
      this.updateprofile.controls['phoneNumber'].setErrors(message);
    }
    else {
      Promise.resolve(this.userDetailsService.checkmobilereg(validateValues)).then(data => {
        if (data !== "already exists") {
          if (check) {
            if (this.updateprofile.valid) {
              this.updateprofile.controls['phoneNumber'].setErrors(null);
              this.registerUser(buttonId);
            } else {
              this.utils.validateAllFormFields(this.updateprofile);
            }
            this.utils.deleteNotifyCookie('otp' + this.userDetails.nickname);
          }
        } else {
          this.updateprofile.controls['phoneNumber'].setErrors({ 'message': 'Phone number already Registered' });
        }
        this.emitterService.broadCastnotificationEvent("");
      });
    }
  }


  updateFormFields(): void {
    if (this.userDetails) {
      this.isRealUser = this.userDetails && this.userDetails.userStatus === "real" ? true : false;
      // this.profileName = this.userDetails["firstName"];
      this.updateprofile.controls["firstName"].setValue(this.userDetails["firstName"]);
      this.updateprofile.controls["lastName"].setValue(this.userDetails["lastName"]);
      if (this.userDetails['bDay']) this.updateprofile.controls['dob'].setValue(this.userDetails['birthDate']);
      if (this.userDetails['bMonth']) this.updateprofile.controls['dob1'].setValue(this.userDetails['birthDate']);
      if (this.userDetails['bYear']) this.updateprofile.controls['dob2'].setValue(this.userDetails['birthDate']);
      if (this.userDetails["gender"]) this.updateprofile.controls["gender"].setValue(this.userDetails["gender"]);
      if (this.userDetails["city"]) this.updateprofile.controls["city"].setValue(this.userDetails["city"]);
      if (this.userDetails["address1"]) this.updateprofile.controls["address1"].setValue(this.userDetails["address1"]);
      if (this.userDetails["playerID"]) this.updateprofile.controls["playerID"].setValue(this.userDetails["playerID"]);
      if (this.userDetails["country"]) this.updateprofile.controls["countryCode"].setValue(this.userDetails["country"]);
      if (this.userDetails["zip"]) this.updateprofile.controls["zipCode"].setValue(this.userDetails["zip"]);
      if (this.userDetails["phone"]) this.updateprofile.controls["phoneNumber"].setValue(this.userDetails["phone"]);
      if (this.userDetails['areaCode']) this.updateprofile.controls['areaCode'].setValue(this.userDetails['areaCode']);
      if (this.userDetails['areaCountryCode']) this.updateprofile.controls['areaCountryCode'].setValue(this.userDetails['areaCountryCode']);
      if (this.userDetails["cellPhoneCountryAreaCode"]) this.utils.setPhoneNumberDropdown("phoneNumberFlag", this.userDetails["cellPhoneCountryAreaCode"], this.updateprofile);
      if (this.userDetails["email"]) this.updateprofile.controls["email"].setValue(this.userDetails["email"]);
      this.onCountrySelect(true);
    }
  }

  registerUser(buttonId) {
    if (this.updateprofile.valid && !this.CustomValidators.phoneNumbervalidationInProgress) {
      this.utils.disableNewButton(buttonId);
      /*Clean the form of unnecessary spaces*/
      this.updateprofile = this.userDetailsService.cleanForm(this.updateprofile);
      let signUpData = this.utils.formControlToParams(this.updateprofile, {});
      signUpData.bDay = this.userDetails['bDay'];
      signUpData.bMonth = this.userDetails['bMonth'];
      signUpData.bYear = this.userDetails['bYear'];
      signUpData.playerID = this.userDetails['playerID'];
      if (!signUpData['state']) {
        signUpData.state = "-NA-";
      }
      signUpData["language"] = language[this.langCode];
      delete signUpData["dob"];
      delete signUpData["dob1"];
      delete signUpData["dob2"];


      signUpData = this.utils.modifyUserData(signUpData);
      let trimmedNumber = this.utils.trimNumberBasedOnCountryRequirement(signUpData.countryCode, signUpData);
      signUpData["phoneNumber"] = trimmedNumber;
      Promise.resolve(this.ajaxService.doProfileUpdate(signUpData)).then(res => {
        if (res && res["success"]["status"] === "SUCCESS") {

          this.userDetailsService.setUserProfileDetails(signUpData);

          this.emitterService.userDataSourceComplete("User Data Updated");
          this.emitterService.broadcastLoadHomeBanner("User_Data_Updated");
          this.utils.enableNewButton(buttonId, "SUCCESS", "Success", "Save");
          Promise.resolve(this.profileSettingService.getProfileData(true)).then(profileData => {
            this.message = true;
            setTimeout(() => {
              this.message = false;
              if (document.body.clientWidth <= 992) {
                this.close.emit();
              }
            }, 5000);
            this.userDetails = this.userDetailsService.getUserProfileDetails();
            this.updateFormFields();
          });
        }
        else {
          this.serverError = this.translationService.instant('errors.error')//"somthing went wrong";
          this.emitterService.broadcastserverError(" ", "/myaccount");
          this.utils.enableNewButton(buttonId, "FAILED", "Failed", "Save");
        }
      });
    } else {
      this.utils.validateAllFormFields(this.updateprofile);
    }
  }
  isReadOnlyAttribute() {
    // if(this.userDetailsService.checkIsPNPUser()) {
    //   return (this.userDetailsService.checkIsEmailUpdated()) ? true: false;
    // } else if(!this.userDetailsService.checkIsPNPUser()) {
    return this.isRealUser ? true : false;
    // }
  }
  openModal(modalId) {
    this.utils.openModal(modalId)
  }

  closeModal(modalId) {
    this.utils.closeModal(modalId)
  }

  @Output() close = new EventEmitter();
  gotoMyAccount() {
    if (document.body.clientWidth <= 992) {
      this.close.emit();
    } else {
      this.router.navigate([this.langCode + '/myaccount'])
    }

  }
  goBack(){
      this.triggerAccountMenu.emit(true);
      $('#navPanelToggle').show();
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
